import React, { useEffect, useState } from 'react';


const EsimQrPage = (props) => {
    return (
        <div className='instructions-page-wrapper'>

        </div>
    );



};

export default EsimQrPage;
